import React from "react";

import AdminDashboard from "./AdminLanding";
import AdminLogout from "./AdminLogout";

import AdminPageContents from "./pages/AdminPageContents";
import AdminTranslations from "./translations/AdminTranslations";
import AdminNotices from "./AdminNotices";
import AdminBanners from "./banners/AdminBanners";
import AdminNews from "./news/AdminNews";
import AdminReviews from "./reviews/AdminReviews";
import AdminReviewers from "./reviewers/AdminReviewers";
import AdminPending from "./pending/AdminPending";
import AdminOrganizations from "./organizations/AdminOrganizations";
import AdminTrainingDocuments from "./training-documents/AdminTrainingDocuments";
import AdminTrainingEducation from "./training-education/AdminTrainingEducation";
import AdminTrainingSurveys from "./training-surveys/AdminTrainingSurveys";
import AdminTrainingVideoSurveys from "./training-video-surveys/AdminTrainingVideoSurveys";
import AdminFaq from "./faq/AdminFaq";
import AdminMassEmail from "./reviews/reviews-email/mass-email/AdminMassEmail";
import AdminNoticeEmail from "./reviews/reviews-email/notice-email/AdminNoticeEmail";
import AdminManagers from "./managers/AdminManagers";

export default [
	{
		path: "/admin",
		exact: true,
		render: props => <AdminDashboard {...props} />
	},
	{
		path: "/admin/logout",
		component: AdminLogout
	},

	{
		path: "/admin/pages",
		component: AdminPageContents
	},
	{
		path: "/admin/translations",
		component: AdminTranslations
	},
	{
		path: "/admin/notices",
		component: AdminNotices
	},
	{
		path: "/admin/banners",
		component: AdminBanners
	},
	{
		path: "/admin/news/add",
		component: AdminNews
	},
	{
		path: "/admin/news/edit",
		component: AdminNews
	},
	{
		path: "/admin/news",
		component: AdminNews
	},
	{
		path: "/admin/reviewers",
		component: AdminReviewers
	},
	{
		path: "/admin/reviews",
		component: AdminReviews
	},
	{
		path: "/admin/mass-email",
		component: AdminMassEmail
	},
	{
		path: "/admin/auto-notice-email",
		component: AdminNoticeEmail
	},
	{
		path: "/admin/registered",
		component: AdminPending
	},
	{
		path: "/admin/organizations",
		component: AdminOrganizations
	},
	{
		path: "/admin/specialists",
		component: AdminManagers
	},
	{
		path: "/admin/faq",
		component: AdminFaq
	},
	{
		path: "/admin/training-documents",
		component: AdminTrainingDocuments
	},
	{
		path: "/admin/training-education",
		component: AdminTrainingEducation
	},
	{
		path: "/admin/training-surveys",
		component: AdminTrainingSurveys
	},
	{
		path: "/admin/training-video-surveys",
		component: AdminTrainingVideoSurveys
	},

	// Not found
	{
		component: () => <h1 className="no-margin">Page not found</h1>
	}
];



// WEBPACK FOOTER //
// ./src/components/admin/adminRoutes.js